<template>
  <v-content class="pa-12">
    <!-- Nevigater -->
    <v-layout mb-6>
      <v-flex shrink d-flex justify-start align-center class="nevigater-link" @click="$router.push('/post-approve')">
        <span>Post Approve</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
        <span>ดูข้อมูล</span>
      </v-flex>
    </v-layout>

    <v-layout mt-6>
      <v-flex shrink style="font-weight: bold;">
        <span>กรองประเภท</span>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex style="color: #3E7662;">
        <v-radio-group hide-details v-model="filterType">
          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF12 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF12 > 0">{{ countRF12
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('1')" :class="checkRadio1 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานการแก้ไขเพิ่มเติมโครงร่างการวิจัย (RF 12_2563)" value="1" />
                  <!--                             label="รายงานแก้ไขเพิ่มเติมโครงร่างการวิจัย (Amendment Protocol)"-->
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF03 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF03 > 0">{{ countRF03
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('4')" :class="checkRadio4 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานความก้าวหน้าของการวิจัย/ขอต่ออายุโครงการ (RF 03_2563)" value="4" />
                  <!--                             label="รายงานความก้าวหน้าและขอต่ออายุโครงการวิจัย (Progress Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF04_2 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF04_2 > 0">{{ countRF04_2
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('8')" :class="checkRadio8 ? 'radio-checked' : ''"
                    color="#3E7662"
                    label="แบบรายงานเหตุการณ์ไม่พึงประสงค์จากยา/เหตุการณ์ไม่คาดคิดจากยา (RF 04_1_2563)"
                    value="8" />
                  <!--                             label="รายงานเหตุการณ์การไม่พึ่งประสงค์จากยา (Adverse Drug Reaction Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF06 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;" v-if="countRF06 > 0">{{ countRF06 }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('5')" :class="checkRadio5 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานแจ้งปิด/สรุปผลการวิจัย (RF 06_2563)" value="5" />
                  <!--                             label="รายงานสรุปผลการวิจัย (Final Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF04_1 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF04_1 > 0">{{ countRF04_1
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('2')" :class="checkRadio2 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานเหตุการณ์ไม่พึงประสงค์ (SAE) (RF 04_2_2563)" value="2" />
                  <!--                             label="รายงานเหตุการณ์การไม่พึ่งประสงค์ (SAE Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF07 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF07 > 0">{{ countRF07
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('7')" :class="checkRadio7 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานการยุติโครงการวิจัยก่อนกําหนด (RF 07_2563)" value="7" />
                  <!--                             label="แจ้งปิดโครงการวิจัยก่อนกำหนด (Terminate)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF05 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF05 > 0">{{ countRF05
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('3')" :class="checkRadio3 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานการไม่ปฏิบัติตามข้อกำหนด (RF 05_2563)" value="3" />
                  <!--                             label="รายงานการเบี่ยงเบนโครงร่างวิจัย (Deviation Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countCorres > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countCorres > 0">{{ countCorres
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('6')" :class="checkRadio6 ? 'radio-checked' : ''"
                    color="#3E7662" label="เอกสารและจดหมายแจ้งเกี่ยวกับงานวิจัย (Correspondence Report)" value="6" />
                  <!--                             label="แจ้งปิดโครงการวิจัยก่อนกำหนด (Terminate)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout class="my-1">
            <v-flex class="xs6 py-1"></v-flex>
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countSusar > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countSusar > 0">{{ countSusar
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('9')" :class="checkRadio9 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานเหตุการณ์ไม่พึ่งประสงค์นอกสถาบัน SUSAR / DMC / DSMB" value="9" />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-radio-group>
      </v-flex>
    </v-layout>

    <!-- Table -->
    <v-layout mt-4>
      <v-flex>
        <form-table :headers="headers" :items="dataPostApproveList" onViewData
          :onViewToReviewerFiles="onViewToReviewerFiles" :viewCorresFile="viewCorresFile"></form-table>
      </v-flex>
    </v-layout>

    <!-- Pagination -->
    <v-layout mt-12>
      <v-flex>
        <v-pagination color="#3E7662" :length="paginateDataSubcommittee.last_page" :total-visible="9"
          @input="getPaginatePostApproveByReviewerIDFilter"
          v-model="paginateDataSubcommittee.current_page"></v-pagination>
      </v-flex>
    </v-layout>

    <!-- Modal View To Reviewer Files -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="viewFileDialog" persistent width="800px" max-width="80%">
          <v-card>
            <!-- Header -->
            <v-card-title class="mb-4 justify-center" style="background-color: #3e7662;color: white;">
              <span class="font-weight-medium font-weight-bold">ดูเอกสารแนบ</span>
            </v-card-title>
            <v-card-text class="justify-center">
              <div v-if="fileList">
                <v-layout v-for="(file, k) in fileList" :key="k">
                  <v-flex ml-2 justify-center>
                    <a :href="file.file" style="color: #3e7662;" target="_blank">
                      <p style="font-size: 16px;text-align: center" class="my-2">
                        {{ file.name ? file.name : "ไม่มีชื่อ" }}
                      </p>
                    </a>
                  </v-flex>
                </v-layout>
              </div>
              <div v-else>
                <v-layout>
                  <v-flex my-12>
                    <p style="font-size: 18px;font-weight: bold; color: #3e7662;text-align: center">
                      ไม่พบเอกสารแนบ
                    </p>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="font-weight: bold" color="#3E7662" text @click="viewFileDialog = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Modal View To Correspondence Files -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="viewCorresFileDialog" persistent width="800px" max-width="80%">
          <v-card>
            <!-- Header -->
            <v-card-title class="mb-4 justify-center" style="background-color: #3e7662;color: white;">
              <span class="font-weight-medium font-weight-bold">ดูเอกสารแนบ</span>
            </v-card-title>
            <v-card-text class="justify-center" v-if="corresFile">
              <v-layout>
                <h2 style="margin: auto">
                  เอกสาร Correspondence
                </h2>
              </v-layout>
              <v-layout my-6>
                <v-flex>
                  <a :href="corresFile.file" style="color: #3e7662;" target="_blank">
                    <p style="font-size: 16px;text-align: center" class="my-2">
                      {{ corresFile.title ? corresFile.title : "ไม่มีชื่อ" }}
                    </p>
                  </a>
                </v-flex>
              </v-layout>
              <div v-if="corresOtherFile.length > 1" class="my-6">
                <v-layout>
                  <h2 style="margin: auto" class="mb-6">
                    เอกสาร อื่นๆ
                  </h2>
                </v-layout>
                <v-layout v-for="(file, k) in corresOtherFile" :key="k">
                  <v-flex ml-2 justify-center>
                    <a :href="file.filePath" style="color: #3e7662;" target="_blank">
                      <p style="font-size: 16px;text-align: center" class="my-2">
                        {{ file.title ? file.title : "ไม่มีชื่อ" }}
                      </p>
                    </a>
                  </v-flex>
                </v-layout>
              </div>
              <div v-else>
                <v-layout>
                  <v-flex my-12>
                    <p style="font-size: 18px;font-weight: bold; color: #3e7662;text-align: center">
                      ไม่พบเอกสารแนบ
                    </p>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="font-weight: bold" color="#3E7662" text @click="viewCorresFileDialog = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
  </v-content>
</template>

<script>
import FormTable from "../../../components/table/FormTable";
import vSelect from "vue-select";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-select/dist/vue-select.css";
import { mapState } from "vuex";
export default {
  name: "Meeting",
  components: {
    FormTable,
    vSelect,
    Loading,
  },
  computed: {
    ...mapState({
      role: (state) => state.Auth.role,
    }),
  },
  data: () => ({
    filterType: "1",
    checkRadio1: true,
    checkRadio2: false,
    checkRadio3: false,
    checkRadio4: false,
    checkRadio5: false,
    checkRadio6: false,
    checkRadio7: false,
    checkRadio8: false,
    checkRadio9: false,
    meetingDialog: false,
    isLoading: false,
    fullPage: true,
    fileList: [],
    paginateDataSubcommittee: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    headers: [
      { text: "ลำดับ", value: "number", align: "center", sortable: false },
      {
        text: "ชื่องานวิจัย",
        value: "nameResearch",
        align: "center",
        sortable: false,
      },
      {
        text: "แบบรายงานการแก้ไขเพิ่มเติมโครงการ",
        value: "nameReport",
        align: "center",
        sortable: false,
      },
      { text: "เรื่องที่", value: "groupID", align: "center", sortable: false },
      {
        text: "ดูเอกสารแนบ",
        value: "onViewToReviewerFiles",
        align: "center",
        sortable: false,
      },
      {
        text: "ดูโครงร่าง",
        value: "viewOutline",
        align: "center",
        sortable: false,
      },
      {
        text: "รหัสโครงการวิจัย",
        value: "researchPass",
        align: "center",
        sortable: false,
      },
      {
        text: "ดูประวัติแบบรายงาน",
        value: "",
        align: "center",
        sortable: false,
      },
      {
        text: "ประเมิน",
        value: "evaluation",
        align: "center",
        sortable: false,
      },
    ],
    dataPostApproveList: [],
    countRF12: 0,
    countRF05: 0,
    countCorres: 0,
    countRF03: 0,
    countRF04_1: 0,
    countRF04_2: 0,
    countRF06: 0,
    countRF07: 0,
    countSusar: 0,
    viewFileDialog: false,
    viewCorresFileDialog: false,
    corresOtherFile: [],
    corresFile: { file: '', title: '' },
  }),
  created() {
    this.getPaginatePostApproveByReviewerIDFilter(1);
  },
  methods: {
    getPaginatePostApproveByReviewerIDFilter(page) {
      this.dataPostApproveList = [];
      let data = {
        page: page,
        id: this.$route.query.id,
        filter: this.filterType,
      };
      this.isLoading = true;
      this.$store
        .dispatch("Research/getPaginatePostApproveByReviewerIDFilter", data)
        .then((res) => {
          console.log("getPaginatePostApproveByReviewerIDFilter: ", res);
          this.countRF12 = res.ResearchAmendmentCount;
          this.countRF04_1 = res.AdverseEventCount;
          this.countRF05 = res.DeviationReportCount;
          this.countRF03 = res.ProgressReportCount;
          this.countRF06 = res.ResearchSummarizeCount;
          this.countRF07 = res.ResearchTerminationCount;
          this.countRF04_2 = res.AdverseDrugEventCount;
          this.countCorres = res.CorrespondenceCount;
          this.countSusar = res.FormSusarCount;
          let i = 1;
          res.data.data.forEach((data) => {
            console.log(data);
            this.dataPostApproveList.push({
              number: i,
              id: data.id,
              researchID: data.researchID,
              rfID: data.id,
              groupID: data.group_id + 1,
              userID: this.$route.query.id,
              role: this.role,
              otherFile: data.otherFile,
              corresFile: data.file,
              corresName: data.name,
              idReport: data.researchID ? data.researchID : "-",
              nameResearch: data.research ? data.research.thResearchName : "-",
              nameReport: data.isRead,
              file: data.file ? data.file : '',
              typeApprove: data.considerType === 1 ? "Full Board" : "Expedited",
              joinMeeting: data.meeting
                ? "รอบที่ " +
                data.meeting.meetingNumber +
                " " +
                data.meeting.meetingDate
                : "-",
              // status: data.isRead === 0 ? 'ยังไม่ได้อ่าน' : 'อ่านแล้ว',
              data: data,
              dataFormReport: data.formData ? data.formData : null,
              researchCode: data.researchCode,
              research_pass: data.research_pass,
              onView: 2,
              filter: this.filterType,
              evaluation:
                this.filterType == 1
                  ? "FormRO05"
                  : "" || this.filterType == 2
                    ? "FormRO07"
                    : "" || this.filterType == 3
                      ? "FormRO08"
                      : "" || this.filterType == 4
                        ? "FormRO06"
                        : "" || this.filterType == 5
                          ? "FormRO09"
                          : "" || this.filterType == 6
                            ? "FormRO19"
                            : "" || this.filterType == 7
                              ? "FormRO10"
                              : "" || this.filterType == 8
                                ? "FormRO07"
                                : "" || this.filterType == 9
                                ? "FormRFSusar"
                                : "",
              rfType:
                this.filterType == 1
                  ? "Amendment"
                  : "" || this.filterType == 2
                    ? "AdverseEvent"
                    : "" || this.filterType == 3
                      ? "Deviation"
                      : "" || this.filterType == 4
                        ? "Progress"
                        : "" || this.filterType == 5
                          ? "Final"
                          : "" || this.filterType == 6
                            ? "Error"
                            : "" || this.filterType == 7
                              ? "Terminate"
                              : "" || this.filterType == 8
                                ? "AdverseDrugEvent"
                                : "" || this.filterType == 9
                                ? "FormSusar"
                                : "",
            });
            i++;
          });
          this.paginateDataSubcommittee.current_page = res.current_page;
          this.paginateDataSubcommittee.from = res.from;
          this.paginateDataSubcommittee.last_page = res.last_page;
          this.paginateDataSubcommittee.per_page = res.per_page;
          this.paginateDataSubcommittee.total = res.total;
          this.paginateDataSubcommittee.to = res.to;
          this.isLoading = false;
          console.log("viewFileDialog1", this.viewFileDialog);
        });
    },
    onViewToReviewerFiles(data) {
      this.viewFileDialog = true;
      this.fileList = data.toReviewerFiles;
    },
    changeStatusMeeting(data) {
      this.meetingDialog = true;
      this.isLoading = true;
      this.$store
        .dispatch("Meeting/getJoinMeeting", data.id)
        .then((res) => {
          this.meetingForm.meetingID = data.id;
          this.meetingForm.meetingName = data.meetingName;
          this.meetingForm.meetingDate = data.meetingDate;
          this.meetingForm.meetingPlace = data.location;
          this.meetingForm.meetingTime = data.time;
          this.meetingForm.isJoin = res.isJoin.toString();
        })
        .then(() => {
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    updateStatusMeeting() {
      this.$store
        .dispatch("Meeting/updateStatusMeeting", this.meetingForm)
        .then((res) => {
          Swal.fire({
            title: "บันทึกเรียบร้อยแล้ว",
            icon: "success",
            position: "center",
            showConfirmButton: false,
            background: "#FAF5F2",
          });
          this.meetingDialog = false;
          window.location.reload();
        })
        .catch((e) => {
          this.isLoading = false;
          if (e.response.data.errors) {
            for (var k in e.response.data.errors) {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: e.response.data.errors[k][0],
                icon: "warning",
                confirmButtonColor: "#3E7662",
              }).then(() => {
                this.$vuetify.goTo(`#${k}`);
              });
            }
          }
        });
    },
    viewCorresFile(item) {
      console.log('item', item);
      this.viewCorresFileDialog = true;
      this.corresOtherFile = item.otherFile;
      this.corresFile.file = item.corresFile;
      this.corresFile.title = item.corresName;
      console.log('corresotherFile', this.corresOtherFile);
      console.log('corresfIle', this.corresFile);
    },
    checkRadio(name) {
      if (name === "1") {
        this.checkRadio1 = true;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "2") {
        this.checkRadio1 = false;
        this.checkRadio2 = true;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "3") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = true;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "4") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = true;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "5") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = true;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "6") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = true;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "7") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = true;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "8") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = true;
        this.checkRadio9 = false;
      }
      if (name === "9") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = true;
      }
      this.getPaginatePostApproveByReviewerIDFilter(1);
    },
  },
};
</script>

<style lang="scss">
// V-select
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__selected

/*.style-chooser .vs__dropdown-menu:hover*/
  {
  background: #3e7662;
  border: solid 2px #3e7662;
  color: #fff;
  /*text-transform: lowercase;*/
  /*font-variant: small-caps;*/
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #fff;
}
</style>
